<template>
    <div>
        <multiselect
            :placeholder="$t('select')"
            v-model="selected"
            :options="optionsSelectbox"
            :class="validateError != '' ? 'box-border-color' : ''"
            @input="handleInput($event)"
            label="text"
            track-by="value"
            :multiple="false"
            :select-label="''"
            :selected-label="''"
            :deselect-label="''"
            :searchable="true"
            :disabled="disabled"
        >
      <span slot="noOptions">
        {{ $t('no_options') }}
      </span>
            <span slot="noResult">
        {{ $t('no_result') }}
      </span>
        </multiselect>
        <span
            class="invalid-feedback-custom"
            v-show="validateError"
            v-html="validateError"
        ></span>
    </div>
</template>

<script>
// Helpers
import handleInput from '@/helpers/handleInput';
import setSelected from '@/helpers/setSelected';

export default {
    props: {
        value: {
            default: null,
        },
        validateError: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(newValue) {
                this.selected = this.setSelected(newValue, this.optionsSelectbox);
            },
        },
    },
    data() {
        return {
            selected: null,
        };
    },
    computed: {
        optionsSelectbox() {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let i = currentYear - 5; i <= currentYear; i++) {
                years.push({
                    value: i,
                    text: i.toString(),
                });
            }
            return years;
        },
    },
    methods: {
        handleInput(event) {
            handleInput.call(this, event);
            this.$emit('input', event ? event.value : null);
        },
        setSelected,
    },
};
</script>
